// removed by extract-text-webpack-plugin
module.exports = {"footerP":"src-components-Footer-___FooterText__footerP___3rxR1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/FooterText.css
// module id = 880
// module chunks = 3